// extracted by extract-css-chunks-webpack-plugin
module.exports = {"default_bio_card":"BioPage__default_bio_card--Z5DWU"};